<template>
  <CCardBody>
    <CDataTable
      :class="classToSet"
      :striped="true"
      :items="items"
      :fields="fields"
      :itemsPerPage="itemsPerPage"
      :pagination="pagination && items.length >= itemsPerPage"
      sorter
      table-filter
      hover
      :responsive="true"
      :active-page="activePage"
    >
      <template #provider="{item}">
        <td v-if="item.identities && item.identities.length">
          {{ item.identities[0].provider }}
        </td>
      </template>
      <template #roles="{item}">
        <td v-if="!displayRoleColumn">--</td>
        <td v-else-if="userHasRoles(item.roles)">
          <div v-for="role in item.roles" v-bind:key="role">
            <CBadge color="secondary">{{ role }}</CBadge>
          </div>
        </td>
        <td v-else><i>No roles</i></td>
      </template>
      <template #organization="{item}">
        <td v-if="item.app_metadata && item.app_metadata.organization">
          {{ item.app_metadata.organization }}
        </td>
        <td v-else>Undefined</td>
      </template>
      <template #userstatus="{item}">
        <td v-if="item.app_metadata && item.app_metadata.trial_user">
          <div v-if="expired(item.app_metadata.trial_expiry)">
            <CBadge color="secondary">Expired trial user</CBadge>
          </div>
          <div v-else>
            <CBadge color="primary">Active trial user</CBadge>
            <div class="float-left">
              <small>
                Expires:
                {{ expiryFormatted(item.app_metadata.trial_expiry) }}</small
              >
            </div>
          </div>
        </td>
        <td v-else-if="item.blocked">
          <CBadge color="danger">Blocked</CBadge>
        </td>
        <td v-else><CBadge color="success">Full user</CBadge></td>
      </template>

      <template #last_login="{item}">
        <td v-if="item.last_login">
          <div>
            {{ daysAgo(item.last_login) }}
          </div>
        </td>
        <td v-else><CBadge color="warning">Never logged in</CBadge></td>
      </template>

      <template #delete="{item}">
        <td class="py-2">
          <CButton
            color="danger"
            variant="outline"
            square
            size="sm"
            @click="deleteItem({ item })"
          >
            Delete
          </CButton>
        </td>
      </template>
      <template #show="{item}">
        <td class="py-2">
          <CButton
            color="primary"
            variant="outline"
            square
            size="sm"
            @click="showUser(item.user_id)"
          >
            Show
          </CButton>
        </td>
      </template>
      <template #editUser="{item}">
        <td class="py-2">
          <CButton
            color="warning"
            variant="outline"
            square
            size="sm"
            @click="editUser(item)"
          >
            Edit
          </CButton>
        </td>
      </template>
      <template #showrole="{item}">
        <td class="py-2">
          <CButton
            color="primary"
            variant="outline"
            square
            size="sm"
            @click="showRole(item)"
          >
            Show Role
          </CButton>
        </td>
      </template>
      <template #edit="{item}">
        <td class="py-2">
          <CButton
            color="warning"
            variant="outline"
            square
            size="sm"
            @click="edit(item)"
          >
            Edit
          </CButton>
        </td>
      </template>
      <template #permission_name="{item}">
        <td class="py-2">
          <span class="permission">
            {{ item.permission_name }}
          </span>
        </td>
      </template>
    </CDataTable>
  </CCardBody>
</template>

<script>
import moment from "moment";
export default {
  name: "TheTable",
  props: {
    items: {
      type: Array,
    },
    fields: {
      type: Array,
    },
    classToSet: {
      type: String,
      default: "",
    },
    templateToShow: {
      type: String,
    },
    loading: {
      type: Array,
    },
    itemsPerPage: {
      type: Number,
      default: 50,
    },
    pagination: {
      type: Boolean,
      default: true,
    },
    activePage: {
      type: Number,
      default: null,
    },
    displayRoleColumn: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    deleteItem(item) {
      this.$emit("deleteItem", item);
    },
    editUser(user) {
      this.$emit("userClicked", user);
    },
    showRole(role) {
      this.$emit("roleClicked", role);
    },
    edit(item) {
      this.$emit("edit", item);
    },
    showUser(role) {
      this.$emit("userDetailsClicked", role);
    },
    expired(ts) {
      return moment().isSameOrAfter(moment(ts));
    },
    expiryFormatted(ts) {
      return moment(ts).format("MMM-DD");
    },
    daysAgo(ts) {
      let hourDiff = moment().diff(moment(ts), "hour");
      if (hourDiff > 24) {
        return Math.floor(hourDiff / 24) + " day(s) ago";
      } else {
        return hourDiff + " hour(s) ago";
      }
    },
    userHasRoles(roles) {
      if (roles[0] === "No roles") {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style>
.permission {
  padding-top: 2px;
  padding-right: 3px;
  padding-bottom: 2px;
  padding-left: 3px;
  color: rgb(46, 44, 44);
  background: lightgray;
  font-weight: bold;
}
</style>
